import { Box, Stack, Typography, type StackProps } from "@mui/material"
import type { FC } from ".."

export type SpecialTagProps = {
  bookDate?: string
  savings?: string
  addedValue?: boolean | null
  specialOfferShortDescription?: string
  sx?: StackProps
}
const SpecialTag: FC<SpecialTagProps> = ({
  bookDate,
  savings,
  addedValue,
  specialOfferShortDescription,
  sx,
}) => {
  return (
    <Stack
      direction="row"
      gap={1.5}
      sx={[
        (theme) => ({
          padding: theme.spacing(2, 3),
          borderRadius: 999,
          background: theme.palette["primary.200"].main,
          position: "absolute",
          top: 16,
          left: 16,
          zIndex: 1,
          [theme.breakpoints.down("md")]: {
            padding: theme.spacing(1, 2),
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Typography
        variant="body.md"
        sx={(theme) => ({
          fontSize: "13px!important",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "100%",
          letterSpacing: "-0.104px",
          color: theme.palette["primary.900"].main,
        })}
      >
        Special
      </Typography>
      {addedValue === true && specialOfferShortDescription && bookDate && (
        <>
          <Box
            component="span"
            sx={(theme) => ({
              width: "1px",
              background: theme.palette["neutral.700"].main,
              opacity: 0.3,
            })}
          />
          <Typography
            variant="body.md"
            sx={(theme) => ({
              fontSize: "13px!important",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "100%",
              letterSpacing: "-0.104px",
              color: theme.palette["neutral.700"].main,
            })}
          >
            Book By {bookDate} and enjoy a
          </Typography>
          <Typography
            variant="body.md"
            sx={(theme) => ({
              fontSize: "13px!important",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "100%",
              letterSpacing: "-0.104px",
              color: theme.palette["primary.900"].main,
            })}
          >
            {specialOfferShortDescription}
          </Typography>
        </>
      )}
      {!addedValue && bookDate && savings && (
        <>
          <Box
            component="span"
            sx={(theme) => ({
              width: "1px",
              background: theme.palette["neutral.700"].main,
              opacity: 0.3,
            })}
          />
          <Typography
            variant="body.md"
            sx={(theme) => ({
              fontSize: "13px!important",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "100%",
              letterSpacing: "-0.104px",
              color: theme.palette["neutral.700"].main,
            })}
          >
            Book By {bookDate} and
          </Typography>
          <Typography
            variant="body.md"
            sx={(theme) => ({
              fontSize: "13px!important",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "100%",
              letterSpacing: "-0.104px",
              color: theme.palette["primary.900"].main,
            })}
          >
            save {savings}
          </Typography>
        </>
      )}
    </Stack>
  )
}

export default SpecialTag
